import { render } from "./AppTile.vue?vue&type=template&id=4b283fbc&scoped=true&ts=true"
import script from "./AppTile.vue?vue&type=script&lang=ts"
export * from "./AppTile.vue?vue&type=script&lang=ts"

import "./AppTile.vue?vue&type=style&index=0&id=4b283fbc&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b283fbc"]])

export default __exports__